import { VBadge } from "@/components/ui";
import type { TaskStatus } from "@/domains/tasks/api/types";

const CONFIG: Record<
  TaskStatus,
  { label: string; color: React.ComponentProps<typeof VBadge>["color"] }
> = {
  todo: { label: "Te doen", color: "neutral" },
  inProgress: { label: "Bezig", color: "info" },
  done: { label: "Klaar", color: "success" },
  blocked: { label: "Geblokkeerd", color: "error" },
};

export function TaskStatusBadge({ status }: { status: TaskStatus }): React.JSX.Element {
  const { label, color } = CONFIG[status];
  return <VBadge color={color}>{label}</VBadge>;
}
